
<!-- {{loggedIn$ | async}} AND  {{loggedInUserId$ | async}} -->
<header (window:resize)="onResize($event)">
  <mat-toolbar>

    <mat-toolbar-row>
      <div class="header-left">
        <div class="header-logo">
          <a routerLink="">
            <img mat-card-image src="assets/images/afriautos_logo.png" alt="afriautos">
          </a>
        </div>

        @if ((!isHandset)) {
          <div class = "header-links">
            <button mat-button class="simple-button" [routerLink]="'buy'" (click)="switchBusinessLine(CarBusinessLine.BUY)">Acheter  <br /> <span class="dot-buy">.</span> </button>
            <button mat-button  class="simple-button"  [routerLink]="'rent'" (click)="switchBusinessLine(CarBusinessLine.RENT)">Louer  <br /> <span class="dot-rent">.</span>  </button>
            <!--
            <button *ngIf = "(!isHandset)" mat-button [routerLink]="'insure'">Assurer</button>
            <button *ngIf = "(!isHandset)" mat-button [routerLink]="'/account/seller-page'"> Je vends </button> -->

            <!-- <button mat-button class="simple-button"  [routerLink]="'keep'" (click)="switchBusinessLine(CarBusinessLine.KEEP)">Entretenir  <br /> <span class="dot-keep">.</span>  </button>
             -->
            <button mat-button class="simple-button"  [routerLink]="'support'" >Support  <br /> <span class="dot-keep">.</span>  </button>
            
          </div>
        }

      </div>

      <div class="header-right">
        @if ((!isHandset)) {
          <div class = "header-icons">
            <!-- <button *ngIf = "(!isHandset)" mat-icon-button [routerLink]="'customer'" >
            <mat-icon class="material-symbols-outlined" [matBadge]="(totalFavorites$ | async)" matBadgeColor="warn">shopping_bag</mat-icon>
          </button>
          <button *ngIf = "(!isHandset)" mat-icon-button [routerLink]="'owner'">
            <mat-icon>storefront</mat-icon>
          </button>
          <button *ngIf = "(!isHandset)" mat-icon-button [routerLink]="'provider'" >
            <mat-icon class="material-symbols-outlined">tire_repair</mat-icon>
          </button>
          <button *ngIf = "(!isHandset)" mat-icon-button [routerLink]="'dealer'" >
            <mat-icon [matBadge]="((isLoggedIn()) === true ? getLoggedInChar() : '')" >account_circle</mat-icon>
          </button>
          <span *ngIf = "(!isHandset)">
            <button *ngIf="isLoggedIn()" mat-button (click)="logout()" >
              Logout
            </button>
          </span> -->
          <!--
          <button mat-button class="simple-button" id="contact-item1">
            <mat-icon>flag_2</mat-icon>
            <span class="button-text">Visitez notre <br /> parc auto </span>
          </button> -->
          <mat-divider></mat-divider>
          <button mat-button class="simple-button" id="contact-item2">
            <mat-icon>phone_in_talk</mat-icon>
            <span class="button-text">Contactez-nous <br /> 672337822 </span>
          </button>
          <!-- <mat-divider vertical style="color: green;"></mat-divider> -->
          <button mat-button class="cta-button-buy" (click)="postNewCar()">
            Vendre
          </button>
          @if (loggedIn) {
            <button mat-button class="simple-button-buy account-button"  (click)="goToAccount()">
              <!-- <mat-icon>logout</mat-icon>Me deconnecter {{getLoggedInUserDetails()}} -->
              <!-- <mat-icon>account_circle</mat-icon><b>{{ (loggedInUserId$ | async)!.substring((loggedInUserId$ | async)!.length - 5) }} </b>  -->
              <mat-icon>account_circle</mat-icon><b>{{(currentUserFname$ | async)}} </b>
            </button>
          }
          @if (loggedIn) {
            <button mat-button class="simple-button-rent" (click)="logout()">
              <!-- <mat-icon>logout</mat-icon>Me deconnecter {{getLoggedInUserDetails()}} -->
              Me deconnecter
            </button>
          }
          @if (!loggedIn) {
            <button mat-button class="cta-button-rent" (click)="login()">
              Me connecter
            </button>
          }
        </div>
      }

      <div class="countries">
        <!-- <mat-label htmlFor="country-select">Choisir pays</mat-label>
        -->
        <!-- <mat-form-field >
        <mat-label> Pays choisis </mat-label>  -->
        <!-- <mat-form-field appearance="outline"> -->
        <!-- <mat-label> <mat-icon>location_on</mat-icon></mat-label> -->
        <mat-select matInput id="country-select" [multiple]="isMultiCountry" [(ngModel)]="selectedCountryCodes" (selectionChange)="updateCountries($event.value)" >
          <mat-select-trigger class = "mini-flags">
            @for (code of selectedCountryCodes; track code; let i = $index) {
              <span class = "mini-flag">
                <img  mat-card-image src="assets/images/country-flags/{{code}}.png" alt="{{code}}">
              </span>
            }
          </mat-select-trigger>

          @for (code of countryCodeOptions; track code; let i = $index) {
            <mat-option matOption class = "country-option" [value]="code" >
              <span class = "mini-flag">
                <img  mat-card-image src="assets/images/country-flags/{{code}}.png" alt="{{code}}">
              </span>
            </mat-option>
          }
        </mat-select>
      <!-- </mat-form-field> -->
    </div>

    <div class="side-menu">

      @if ((isHandset)) {
        <button mat-icon-button (click)="sidenav.toggle()" >
          @if (!sidenav.opened) {
            <mat-icon> menu </mat-icon>
          }
          @if (sidenav.opened) {
            <mat-icon> close </mat-icon>
          }
        </button>
      }
    </div>
  </div>
</mat-toolbar-row>
</mat-toolbar>
</header>

<mat-sidenav-container>
  <mat-sidenav #sidenav="matSidenav" position="end">
    <!-- <h4 class="sidenav-title">Menu</h4>
    <mat-divider></mat-divider> -->
    <div class="sidenav-section">
      <button mat-button class="simple-button"  [routerLink]="'buy'" (click)="sidenav.toggle(); switchBusinessLine(CarBusinessLine.BUY)">
        Acheter
      </button>

      <button mat-button class="simple-button" [routerLink]="'rent'" (click)="sidenav.toggle(); switchBusinessLine(CarBusinessLine.RENT)">
        Louer
      </button>

      <!-- <button mat-button class="simple-button"  [routerLink]="'keep'" (click)="sidenav.toggle(); switchBusinessLine(CarBusinessLine.KEEP)">
        Entretenir
      </button> -->

      <button mat-button class="simple-button"  [routerLink]="'support'" (click)="sidenav.toggle()">
        Support
      </button>

    </div>

    <mat-divider></mat-divider>
    <!-- 
    <div class="sidenav-section">
      <button mat-button class="simple-button"  [routerLink]="'customer'" (click)="sidenav.toggle()">
        Acheteur
      </button>

      <button mat-button class="simple-button" [routerLink]="'owner'" (click)="sidenav.toggle()">
        Propriétaire
      </button>

      <button mat-button class="simple-button" [routerLink]="'provider'" (click)="sidenav.toggle()">
        Provider
      </button>
    </div>

    <mat-divider></mat-divider> 
    -->

    <div class="buttons-section">

      <button mat-button class="cta-button-buy" (click)="sidenav.toggle(); postNewCar()">
        <mat-icon>shopping_bag</mat-icon> Vendre
      </button>
      @if (loggedIn) {
        <button mat-button class="simple-button" mat-button (click)="sidenav.toggle(); logout()">
          <mat-icon>logout</mat-icon>Me deconnecter (<b>{{(currentUserFname$ | async)}}) </b>
        </button>
      }
      @if (!loggedIn) {
        <button mat-button class="cta-button-rent" (click)="sidenav.toggle(); login()">
          <mat-icon>login</mat-icon>Me connecter
        </button>
      }
    </div>

    @if (loggedIn) {
        <app-dealer-menu></app-dealer-menu>
      }

  </mat-sidenav>

  <mat-sidenav-content>

    @if ((isHandset)) {
      <div class="content">
        <router-outlet></router-outlet>
      </div>
    }

  </mat-sidenav-content>
</mat-sidenav-container>

@if ((!isHandset)) {
  <div class="content">
    <router-outlet></router-outlet>
  </div>
}

<app-footer class="app-footer"></app-footer>
